import { Theme } from './theme.mjs';

/* Settings Button */

const hamburgerActive = document.getElementById('hamburger-active');
const hamburgerInactive = document.getElementById('hamburger-inactive');
const sideBarWrapper = document.getElementById('side-bar-wrapper');

function toggleMenuButton() {
  hamburgerActive.hidden = !hamburgerActive.hidden;
  hamburgerInactive.hidden = !hamburgerInactive.hidden;
}

// When the settings button is clicked, toggle its look (either hamburger or
// cross) and toggle the navigation/settings side bar.
hamburgerActive.addEventListener("click", () => {
  sideBarWrapper.close();
});
hamburgerInactive.addEventListener("click", () => {
  toggleMenuButton();
  sideBarWrapper.show();
});
sideBarWrapper.addEventListener("close", () => {
  toggleMenuButton();
});


/* Theme Settings */

var currentTheme = Theme.init();
Theme.setCurrent(currentTheme);

const lightThemeButton = document.getElementById('theme-button-light');
const darkThemeButton = document.getElementById('theme-button-dark');

switch (Theme.getCurrent()) {
  case Theme.lightValue:
    lightThemeButton.checked = true;
    darkThemeButton.checked = false;
    break;
  case Theme.darkValue:
    lightThemeButton.checked = false;
    darkThemeButton.checked = true;
    break;
  default:
    break;
}

lightThemeButton.addEventListener("click", () => {
  Theme.setStored(Theme.lightValue);
  document.documentElement.setAttribute('data-site-theme', 'light');
  lightThemeButton.checked = true;
  darkThemeButton.checked = false;
  sideBarWrapper.close();
});

darkThemeButton.addEventListener("click", () => {
  Theme.setStored(Theme.darkValue);
  document.documentElement.setAttribute('data-site-theme', 'dark');
  lightThemeButton.checked = false;
  darkThemeButton.checked = true;
  sideBarWrapper.close();
});

